import React from 'react';
import { AccentColorOptions, useAccentColor } from 'epic-ue-theme';
import styled from 'styled-components';

const Styled = styled.div`
    transform: rotate(90deg);
`;

interface CompareSliderProps {
    accentColor?: AccentColorOptions;
}

export const CompareSlider = ({accentColor = 'forest'}: CompareSliderProps):JSX.Element => {
    const color = useAccentColor(accentColor);
    return (
        <Styled>
            <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M58 29C58 45.0163 45.0163 58 29 58C12.9837 58 0 45.0163 0 29C0 12.9837 12.9837 0 29 0C45.0163 0 58 12.9837 58 29ZM29.0039 12.5644L36.8146 20.3751L35.7539 21.4358L29.0039 14.6858L22.2539 21.4358L21.1932 20.3751L29.0039 12.5644ZM28.9999 43.3146L22.2499 36.5646L21.1893 37.6253L28.9999 45.4359L36.8106 37.6253L35.7499 36.5646L28.9999 43.3146Z" fill={color}/>
            </svg>
        </Styled>
    );
}
